import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import EKhataRegistration from './EKhataRegistration'
function EKhathaIndex() {
  return (
    <div>
        <Navbar />
        <EKhataRegistration />
        <Footer/>
      
    </div>
  )
}

export default EKhathaIndex
